<template>
	<div class="col-12">
		<div id="light-wall" class="data-block">
			<div class="mb-4 relative table-wall-wrapper">
				<div
					v-show="!disable.left"
					class="left-side-wall h-100"
				>
					<div
						class="arrow-table"
						@click.prevent="scrollTable(0)"
					>
						<div class="relative h-100 inverse">
							<ButtonArrowIcon class="d-flex" />
						</div>
					</div>
					<div class="rect-shadow d-none d-lg-block" />
				</div>
				<div id="table-wall-wrapper">
					<client-only>
						<table>
							<div id="table-wall">
								<tr v-for="row in rows" :key="row">
									<td
										v-for="(col, index) in cols"
										:id="`${row*44 + index + 1}`"
										:key="col"
									>
										<div
											class="brick"
											:style="getCustomColor(row*44 + index + 1)"
											:class="{
												'brick--owner': order && order.brick_id === row*44 + index + 1,
												'brick--selected': selectedBrick === row*44 + index + 1,
												'brick--active': bricks.find(el => el.id == row*44 + index + 1),
											}"
											@click="selectBrick(row*44 + index + 1)"
										/>
									</td>
								</tr>
							</div>
						</table>
					</client-only>
				</div>
				<div
					v-show="!disable.right"
					class="right-side-wall h-100"
				>
					<div
						class="arrow-table"
						@click.prevent="scrollTable(1)"
					>
						<div class="inverse relative h-100">
							<ButtonArrowIcon class="d-flex" />
						</div>
					</div>
					<div class="rect-shadow d-none d-lg-block" />
				</div>
			</div>
		</div>
		<div class="d-flex align-items-center justify-content-center d-lg-none">
			<div
				class="navigation-wall-button inverse"
				:class="disable.left ? 'navigation-wall-button--disabled': 'navigation-wall-button--active'"
				@click="scrollTable(0)"
			>
				<ButtonArrowIcon class="d-flex" />
			</div>
			<div class="relative mx-2">
				<div id="rect-view-wall" class="rect-view-wall" />
				<img src="/stena-sveta/wall-navigation.png" alt="wall-navigation">
			</div>
			<div
				class="navigation-wall-button"
				:class="disable.right ? 'navigation-wall-button--disabled': 'navigation-wall-button--active'"
				@click="scrollTable(1)"
			>
				<ButtonArrowIcon class="d-flex" />
			</div>
		</div>
		<b-modal
			v-if="order"
			id="modal-brick-order"
			v-model="showModalOrder"
			content-class="modal-content-glass-wall"
			body-class="modal-body-glass-wall"
			header-class="modal-header-glass-wall"
			hide-footer
			centered
		>
			<template #modal-header>
				<div class="w-100 mb-4">
					<div class="row d-flex justify-content-between">
						<div class="col-auto align-self-center glass-text">
							Элемент #{{ order.brick_id }}
						</div>
						<div class="col-auto">
							<span class="icon-close" @click="showModalOrder = false" />
						</div>
					</div>
				</div>
			</template>
			<div>
				<div v-if="[2, 8].includes(order.status)" class="glass-text">
					<div v-if="$auth.user" class="modal-glass-wall-title mb-2">
						{{ $auth.user.first_name }} {{ $auth.user.last_name }}
					</div>
					<div class="strong">
						{{ order.program_name }}
					</div>
					<div class="mt-4">
						Совсем скоро ваш именной элемент появится на СТЕНЕ СВЕТА.
					</div>
					<div class="mt-2">
						Расскажите своим одногруппникам про СТЕНУ СВЕТА. Вместе вдохновим тех, кто идет следом.</a>.
					</div>
				</div>
				<div v-else>
					<div v-if="$auth.user" class="modal-glass-wall-title mb-2">
						{{ $auth.user.first_name }} {{ $auth.user.last_name }}
					</div>
					<div class="my-3 glass-text">
						Ваша заявка на покупку именного элемента в СТЕНЕ СВЕТА {{ statuses[order.status] }}
					</div>
					<div>
						<b-button
							variant="dark"
							class="glass-button"
							:disabled="isSubmitLoading"
							@click="redirectToOrder"
						>
							<b-spinner v-if="isSubmitLoading" style="margin-right: 15px; width: 1.3em; height: 1.3em;" />
							<span>Перейти к заявке</span>
						</b-button>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal
			id="modal-brick"
			v-model="show"
			content-class="modal-content-glass-wall"
			body-class="modal-body-glass-wall"
			header-class="modal-header-glass-wall"
			hide-footer
			centered
		>
			<template #modal-header>
				<div class="w-100 mb-4">
					<div class="row d-flex justify-content-between">
						<div class="col-auto align-self-center glass-text">
							Элемент #{{ selectedBrick }}
						</div>
						<div class="col-auto">
							<span class="icon-close" @click="show = false" />
						</div>
					</div>
				</div>
			</template>
			<div>
				<div v-if="order && [2, 8].includes(order.status)" class="glass-text">
					Ваш именной элемент уже ждет вас. Приобрести второй, к сожалению, нельзя. Но вы можете рассказать про СТЕНУ СВЕТА другим выпускникам пройденной программы и таким образом запечатлеть вашу совместную историю.
				</div>
				<div v-else>
					<div v-if="$auth.user" class="modal-glass-wall-title mb-2">
						{{ $auth.user.first_name }} {{ $auth.user.last_name }}
					</div>
					<div v-if="isAlumni">
						<span v-if="order && order.status == 12" class="glass-text">
							Вы не можете подать заявку на данный элемент, так как ваша заявка на покупку элемента {{ order.brick_id }} не прошла модерацию.
						</span>
						<span v-else-if="order" class="glass-text">
							У вас уже есть заявка на покупку элемента {{ order.brick_id }}. При отправке заявки на новый элемент вы потеряете бронь на предыдущий.
						</span>
						<span v-else class="glass-text">
							Выберите одну программу, которая будет представлять вас на СТЕНЕ СВЕТА.
						</span>
						<div v-if="!order">
							<div class="d-flex align-items-center mt-3">
								<div
									v-for="(program, index) in userPrograms"
									:key="program.id"
									class="item-glass-wall-program glass-text"
									:class="selectedProgram === program.id ? 'item-glass-wall-program--selected' : ''"
									@click="selectProgram(program)"
								>
									{{ program.name }}
								</div>
							</div>
							<div v-if="isCustomProgram" class="mt-3">
								<b-form-input
									v-model="formValues.program_name"
									placeholder="Введите название"
									class="glass-wall-input"
								/>
							</div>
						</div>
						<div
							id="checkbox-agreement-glass-wall"
							class="mt-3"
						>
							<b-form-checkbox
								v-model="formValues.publicOfferAgreement"
								name="checkbox-agreement"
								:value="true"
								:unchecked-value="false"
								data-action="publicOfferAgreement"
							>
								Отправляя форму, я принимаю
								<a
									href="https://sk.skolkovo.ru/storage/formulate_agreements/85/SFrtMHje0cjI3LC5DCZyqRxTPOIoYgMIwN2uSNXS.pdf"
									target="_blank"
									class="glass-text-decoration"
								>
									условия договора публичной оферты
								</a>
							</b-form-checkbox>
							<span v-if="isErrorAgreement" class="text-danger small">
								Необходимо принять условия
							</span>
						</div>
						<div class="mt-3 modal-glass-wall-footer">
							<div>
								<b-button
									v-if="order && order.status != 12"
									variant="dark"
									class="glass-button"
									:disabled="isSubmitLoading"
									@click="changeOrderBrick"
								>
									<b-spinner v-if="isSubmitLoading" style="margin-right: 15px; width: 1.3em; height: 1.3em;" />
									{{ isSubmitLoading ? 'Обработка...' : 'Изменить элемент' }}
								</b-button>
								<b-button
									v-else-if="!order"
									variant="dark"
									class="glass-button"
									:disabled="disableButtonRequest"
									@click="submitOrder"
								>
									<b-spinner v-if="isSubmitLoading" style="margin-right: 15px; width: 1.3em; height: 1.3em;" />
									{{ isSubmitLoading ? 'Отправляется...' : 'Отправить заявку' }}
								</b-button>
							</div>
							<div
								v-if="!isCustomProgram && !order"
								class="glass-text-decoration mt-2 mt-md-0 ml-3 text-right"
								@click="setCustomProgram"
							>
								Вашей программы нет в списке? <br>Укажите другую программу
							</div>
						</div>
						<div v-if="errorMessage" class="text-danger mt-2">
							{{ errorMessage }}
						</div>
					</div>
					<div v-else>
						<span class="glass-text">
							Мы не знаем вас как выпускника. Пройдите модерацию, нажав на кнопку ниже. После этого ваши данные будут проверены и вы получите на почту письмо с подтверждением
						</span>
						<div class="mt-4 d-flex align-items-center justify-content-between">
							<b-button
								variant="dark"
								class="glass-button"
								:disabled="isSubmitLoading"
								@click="sendRequestAlumni"
							>
								<b-spinner v-if="isSubmitLoading" style="margin-right: 15px; width: 1.3em; height: 1.3em;" />
								{{ isSubmitLoading ? 'Отправляется...' : 'Пройти' }}
							</b-button>
							<div class="glass-text-decoration" @click="redirectToAlumni">
								Как стать выпускником
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import formulateFormScenario from '~/mixins/formulateFormScenario';
import {
	mapActions, mapMutations,
} from 'vuex';
import ButtonArrowIcon from '~/static/stena-sveta/ButtonArrowIcon.vue';
import { BOOTSTRAP_BREAKPOINTS } from '~/utils/dictionaries';
import checkScreenWidth from '~/mixins/checkScreenWidth';

export default {
	components: {
		ButtonArrowIcon,
	},
	mixins: [formulateFormScenario, checkScreenWidth],
	inject: ['setOrder'],
	data() {
		return {
			BOOTSTRAP_BREAKPOINTS,
			productsSumWithDiscount: 0,
			productsSum: 0,
			discountValue: 0,
			productsCount: [],
			formErrors: [],
			bricks: [],
			selectedBrick: null,
			selectedProgram: null,
			show: false,
			showModalOrder: false,
			isSubmitLoading: false,
			isCustomProgram: false,
			brickStatuses: [],
			brickTypes: [],
			orderStatuses: [],
			userPrograms: [],
			order: null,
			errorMessage: null,
			coordinateX: 0,
			coordinateViewX: 0,
			paramsView: {
				count: 3,
				width: 120,
				step: 50,
			},
			disable: {
				left: true,
				right: false,
			},
			statuses: {
				1: 'не оплачена',
				2: 'оплачена',
				3: 'на проверке',
				4: 'одобрена',
				5: 'отменена',
				6: 'не исправна',
				7: 'требует доплаты',
				8: 'оплачена',
				10: 'удалена',
				11: 'ожидает модерации',
				12: 'не прошла модерацию',
			},
			isErrorAgreement: false,
		};
	},
	computed: {
		isAlumni() {
			return this.$store.getters['profile/isAlumni'];
		},
		finalPrice() {
			if (!this.priceWithPromocode) {
				if (this.discountPrice > 0 && this.discount) return this.discountPrice;
				return this.can_return_vat_selected
					? this.priceWithoutVat
					: this.amount;
			}

			return this.priceWithPromocode;
		},
		originalPrice() {
			return this.can_return_vat_selected
				? this.priceWithoutVat
				: this.amount;
		},
		priceWithoutVat() {
			return this.allProductsByType.reduce(
				(sum, product) => parseFloat(sum) + parseFloat(product?.price_without_vat ?? 0),
				0,
			);
		},
		rows() {
			return [...Array(35)].map((a, b) => b);
		},
		cols() {
			return [...Array(44)].map((a, b) => b);
		},
		disableButtonRequest() {
			if (this.isSubmitLoading) return true;
			if (this.formValues.program_name) {
				if ([null, ''].includes(this.formValues.program_name)) return true;
				return false;
			}
			return true;
		},
	},
	watch: {
		show: {
			handler(value) {
				if (!value) {
					this.selectedBrick = null;
					this.selectedProgram = null;
					this.isCustomProgram = false;
					this.errorMessage = null;
					this.formValues.brick_id = null;
					this.formValues.program_id = null;
					this.$set(this.formValues, 'program_name', null);
				}
			},
		},
		'$auth.user': {
			async handler(user) {
				await this.getBricksAndOrder();
			},
			immediate: true,
		},
		screenWidth: {
			handler() {
				this.resetPositionWall();
				this.changeParamsView();
			},
		},
	},
	mounted() {
		this.changeParamsView();
	},
	methods: {
		...mapActions({
			showLoginPopup: 'authModal/showLogin',
		}),
		changeParamsView() {
			setTimeout(() => {
				const ele = document.getElementById('table-wall-wrapper');
				const eleTable = document.getElementById('table-wall');
				const eleView = document.getElementById('rect-view-wall');

				this.paramsView.count = Math.ceil(eleTable.clientWidth / ele.clientWidth);
				this.paramsView = {
					...this.paramsView,
					width: Math.ceil(219 / this.paramsView.count),
					step: Math.ceil(219 / this.paramsView.count),
				};
				eleView.style.width = `${this.paramsView.width}px`;
			}, 300);
		},
		resetPositionWall() {
			setTimeout(() => {
				this.disable = { left: true, right: false };
				const ele = document.getElementById('table-wall-wrapper');
				const eleView = document.getElementById('rect-view-wall');
				this.coordinateX = 0;
				this.coordinateViewX = 0;
				ele.scrollLeft = this.coordinateX;
				eleView.style.left = `${this.coordinateViewX}px`;
			}, 300);
		},
		scrollTable(direction) {
			if ((direction === 0 && !this.disable.left) || (direction === 1 && !this.disable.right)) {
				this.disable = { left: false, right: false };
				const ele = document.getElementById('table-wall-wrapper');
				const eleView = document.getElementById('rect-view-wall');

				const dir = (direction === 0 ? (-1) : 1);
				const diff = dir * Math.ceil(ele.scrollWidth / this.paramsView.count);
				this.coordinateX += diff;
				this.coordinateViewX += dir * this.paramsView.step;
				ele.scrollBy({ left: diff });

				eleView.style.left = `${this.coordinateViewX}px`;

				if (this.coordinateX + diff >= ele.scrollWidth) this.disable.right = true;
				if (this.coordinateX + diff < 0) this.disable.left = true;
			}
		},
		setCustomProgram() {
			this.isCustomProgram = true;
			this.selectedProgram = null;
			this.formValues.program_id = null;
			this.$set(this.formValues, 'program_name', null);
		},
		async submitOrder() {
			this.errorMessage = null;
			this.isErrorAgreement = false;

			if (this.formValues.program_name) {
				if (this.formValues.publicOfferAgreement) {
					this.isSubmitLoading = true;
					await this.submit();
					this.show = false;
					this.isSubmitLoading = false;
				} else {
					this.isErrorAgreement = true;
				}
			} else {
				this.errorMessage = 'Выберите или укажите программу';
			}
		},
		async getBricksAndOrder() {
			await this.$api.getBricks().then((res) => {
				this.bricks = res.data.bricks;
				this.brickStatuses = res.data.brickStatuses;
				this.brickTypes = res.data.brickTypes;
				this.orderStatuses = res.data.orderStatuses;
				this.order = res.data.order;
				this.userPrograms = res.data.programs;
				if (this.userPrograms.length > 0) this.selectProgram(this.userPrograms[0]);
				this.setOrder(res.data.order);
			});
		},
		selectBrick(cell) {
			if (this.order && this.order.brick_id === cell) {
				this.showModalOrder = true;
			} else if (!this.bricks.find((el) => el.id === cell)) {
				if (this.$auth.user) {
					this.selectedBrick = this.selectedBrick === cell ? null : cell;
					this.formValues.brick_id = this.selectedBrick;
					this.show = true;
				} else {
					this.showLoginPopup();
				}
			}
		},
		selectProgram(program) {
			this.selectedProgram = program.id;
			this.formValues.program_id = program.id;
			this.$set(this.formValues, 'program_name', program.name);
			this.isCustomProgram = false;
		},
		async changeOrderBrick() {
			this.isSubmitLoading = true;
			await this.$api.changeBrick({ brick_id: this.selectedBrick }).then(() => {
				window.location = `${this.$route.path + this.order.hash}`;
				this.isSubmitLoading = false;
			});
		},
		async sendRequestAlumni() {
			this.isSubmitLoading = true;
			const response = await this.$api.alumniRequest(this.$route.fullPath);
			if (response.result === true) {
				await this.submit();
				this.isSubmitLoading = false;
			}
		},
		redirectToOrder() {
			window.location = `${this.$route.path + this.order.hash}`;
		},
		redirectToAlumni() {
			window.location = '/alumni';
		},
		hexToRgb(color) {
			const hex = color.startsWith('#') ? color : `#${color}`;

			const r = parseInt(hex.slice(1, 3), 16);
			const g = parseInt(hex.slice(3, 5), 16);
			const b = parseInt(hex.slice(5, 7), 16);

			return `${r}, ${g}, ${b}`;
		},
		getCustomColor(id) {
			const brick = this.bricks.find((el) => el.id === id);
			if (!brick) return {};

			const color = brick.color || brick.program?.color;
			if (!color) return {};

			const rgb = this.hexToRgb(color);
			return {
				boxShadow: `0 0 10px rgba(${rgb}, 0.4), 0 0 20px rgba(${rgb}, 0.6)`,
				background: `linear-gradient(rgba(${rgb}, 1), rgba(${rgb}, 0.4))`,
				borderImage: 'unset',
			};
		},
	},
};
</script>
